import React, { useState } from "react";
import { CiEdit } from "react-icons/ci";
import { AiFillEdit } from "react-icons/ai";
import profile_image from "../../assets/images/ajit_image.jpeg";
import styles from "./Profile.module.css";
import { Box } from "@mui/material";

const ProfileBanner = ({banner}) => {
    // const [banner, setBanner] = useState(null);
    // const [buttonText, setButtonText] = useState("Choose");

    // const handleImageChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setBanner(reader.result);
    //             setButtonText("Change");
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };

    return (
        <div className="banner-upload-container" >
            <div className="banner-frame">

                {banner ? (
                    <img src={banner} alt="Banner" className="banner-image" />
                ) : (
                    <div className="placeholder"></div>
                )}
            </div>


            {/* <input
                type="file"
                id="bannerInput"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: "none" }}
            /> */}
            {/* <button
                className={styles.banner_button}
                onClick={() => document.getElementById("bannerInput").click()}
            >
                <AiFillEdit />
            </button> */}
           
        </div>
    );
};

export default ProfileBanner;
